export default __webpack_public_path__ + "assets/info-outline-light.svg";